import React, { useState, Suspense, lazy } from 'react';
import { useNavigate, useParams, NavLink } from 'react-router-dom';
import SideNav from '../components/SideNav';
import DayOff from '../components/DayOff';
import Alerts from '../components/Alerts';
import TopTabs from '../components/TopTabs';
import OfficeTimesheetListCp from '../components/OfficeTimesheetListCp';
import TutorialCp from '../components/TutorialCp';
import CarryOverCP from '../components/CarryOverCp';
// import ServicePartListCp from '../components/ServicePartListCp';

const HolidayCmpnt = lazy(() => import('../components/HolidayCmpnt'));
const OvertimeCmpnt = lazy(() => import('../components/OvertimeCmpnt'));
// const InventoryCmpnt = lazy(() => import('../components/InventoryCmpnt'));

const SettingsPage = () => {
  const { key } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(key || 'holidays');

  const holidays = { name: 'Holiday', href: 'holidays', current: activeTab === 'holidays' };
  // const inventory = { name: 'Equipment Price', href: 'inventory', current: activeTab === 'inventory' };
  const overtime = { name: 'Overtime', href: 'overtime', current: activeTab === 'overtime' };
  const carryOver = { name: 'Carry-Over', href: 'carryover', current: activeTab === 'carryover' };
  const timesheetList = { name: 'Timesheet List', href: 'timesheet-list', current: activeTab === 'timesheet-list' };
  const tutorial = { name: 'How-To', href: 'tutorial-list', current: activeTab === 'tutorial-list' };
  

  const tabs = [holidays, overtime, carryOver, timesheetList, tutorial];

  const handleTabClick = (href) => {
    setActiveTab(href);
    navigate(`/${href}`);
  };

  return (
    <div className="max-w-[1220px] mx-auto grid grid-cols-1 md:grid-cols-[200px_minmax(540px,_1fr)_260px] gap-x-4">
      <div className="hidden md:block">
        <div className='pt-6 pr-3'>
          <SideNav />
        </div>
      </div>

      <div className="mt-10 p-4">
        <h1 className='pb-5'>Settings</h1>
        <br/>
        <NavLink className="text-blue-600 hover:underline mb-4 inline-block" to="/equipment_list">Equipment List</NavLink>

        <TopTabs tabs={tabs.map(tab => ({ ...tab, current: tab.href === activeTab }))} onTabClick={handleTabClick} />
        <br/>
        <Suspense fallback={<div>Loading...</div>}>
          {activeTab === 'holidays' && <HolidayCmpnt />}
          {/* {activeTab === 'inventory' && <InventoryCmpnt />} */}
          {activeTab === 'overtime' && <OvertimeCmpnt />}
          {activeTab === 'carryover' && <CarryOverCP />}
          {activeTab === 'timesheet-list' && <OfficeTimesheetListCp />}
          {activeTab === 'tutorial-list' && <TutorialCp />}
        </Suspense>
      </div>


      {/* <div className="hidden md:block ">
        <div className='pt-4'>
          <div className='border-2'>
            <DayOff />
          </div>
          <br />
          <Alerts />
        </div>
      </div> */}
    </div>
    
  )
}

export default SettingsPage;
